// extracted by mini-css-extract-plugin
export default {"container":"style_container__fEqmg","background":"style_background__bYCW-"};